import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="py-24 md:py-32 border-t border-border" data-id="element-11">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-12">
        <div className="mb-16" data-id="element-13">
          <h2 className="text-2xl md:text-3xl font-semibold text-primary tracking-tight" data-id="element-14">
            About
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16" data-id="element-15">
          <div className="lg:col-span-7" data-id="element-16">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.6
          }} className="space-y-6 text-lg text-secondary leading-relaxed mb-16" data-id="element-17">
              <p data-id="element-18">
                Karan Dhir is an AI Product Manager at Genentech (Roche), where
                he owns the marketing measurement platform directing over $1.2B
                in annual spend. He builds the systems, measurement,
                experimentation, governance, and the decision layer on top, that
                let leaders in regulated, high-stakes environments trust AI
                enough to act on it.
              </p>
              <p data-id="element-19">
                Previously at Amazon and Walmart on ranking, experimentation,
                and marketplace measurement.
              </p>
            </motion.div>
          </div>

          <div className="lg:col-span-5 flex items-start lg:items-center" data-id="element-20">
            <motion.div initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="glass-card p-8 md:p-10 rounded-2xl sticky top-32" data-id="element-21">
              <blockquote className="text-xl md:text-2xl text-primary leading-relaxed font-medium tracking-tight" data-id="element-22">
                "I kept following the same question: how do organizations
                actually make better decisions with AI? Into progressively
                higher-stakes environments."
              </blockquote>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}